var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94299 0.0864418L16.8483 0L23.9136 6.94299L24 16.8483L17.057 23.9136L7.15168 24L0.0864418 17.057L0 7.15168L6.94299 0.0864418Z",
    fill: "#D92E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6C11.4877 6 10.9657 6.42739 11.0005 7.02469L11.25 13.7617C11.253 13.9564 11.3317 14.1424 11.4696 14.2803C11.6102 14.421 11.801 14.5 11.9999 14.5C12.1988 14.5 12.3896 14.421 12.5302 14.2803C12.6681 14.1424 12.7468 13.9564 12.7498 13.7617L12.9993 7.02469C13.0341 6.42739 12.5121 6 11.9999 6ZM12.0097 7.0074C12.0097 7.0074 12.0097 7.00735 12.0096 7.00724L12.0097 7.0074ZM11.9901 7.0074L11.9902 7.00724C11.9901 7.00735 11.9901 7.0074 11.9901 7.0074ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red-alert.140edf7e265c7fe07d0377e007fe1df1.svg";
export { ForwardRef as ReactComponent };